import React from 'react';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import TextareaAutosize from 'react-textarea-autosize';
import numeral from 'numeral';
import './index.css';

export default class SimpleSiteInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            site: this.props.site,
        }   
    }
    componentDidUpdate(prevProps){
        const { attributeName } = this.props;
        if (prevProps.site[attributeName] !== this.props.site[attributeName]) {
            this.setState({
                site: this.props.site,
            });
        }
    }
    render() {
        const { labels, callback, attributeName, textArea, disabled, isNumeric, note } = this.props;
        const { site } = this.state;
        let valueToDisplay = site[attributeName];
        if (isNumeric) {
            valueToDisplay = numeral(site[attributeName]).format('0,0');
        }
        return (
            <div className="site-attribute__text-input">
                <Label className="site-attribute__text-input-label">{labels[attributeName]}</Label>
                <FormGroup>
                    {!textArea ?
                        <Input
                            className="site-attribute__text-input-box"
                            onChange={(e) => callback(attributeName, isNumeric ? e.target.value.replace(/,/g, '') : e.target.value)}
                            value={valueToDisplay}
                            placeholder={site[attributeName]}
                            disabled={disabled}
                        />
                        :
                        <TextareaAutosize
                            type="textarea"
                            className="site-attribute__text-input-box custom-textarea"
                            onChange={(e) => callback(attributeName, e.target.value)}
                            value={site[attributeName]}
                            placeholder={site[attributeName]}
                            minRows={3}
                            disabled={disabled}
                        />
                    }
                </FormGroup>
                {note && <p className="site-attribute__text-input-note">{note}</p>}
            </div>
        );
    }
}